import { Button } from '@radix-ui/themes';
import { MISC_URLS } from 'classes/helpers/url.helper';
import { SuperAdminIcon } from 'components/common/custom-icon/shorthands';
import { UserRole } from 'lib_ts/enums/auth.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useMemo } from 'react';
import { useAuthStore } from 'stores/use-auth-store';

const ENABLE_PRE_FILLED_URL = false;

export const RequestChangeButton = (props: { errorID?: string }) => {
  const current = useAuthStore((s) => s.current);

  const url = useMemo(() => {
    if (!ENABLE_PRE_FILLED_URL) {
      return MISC_URLS.ERROR_TYPE_REQUEST_CHANGE_FORM;
    }

    return (
      MISC_URLS.ERROR_TYPE_REQUEST_CHANGE_FORM +
      new URLSearchParams({
        email: current.email,
        errorID: props.errorID ?? '',
      }).toString()
    );
  }, [current.email, props.errorID]);

  if (current.role !== UserRole.admin) {
    // only super admins can see this button
    return null;
  }

  return (
    <Button
      variant={RADIX.BUTTON.VARIANT.TABLE}
      color={RADIX.COLOR.SECONDARY}
      onClick={() => window.open(url, '_blank')}
    >
      <SuperAdminIcon /> Request Change
    </Button>
  );
};
